import React from "react";
import { useState } from "react";
import "./hero.css"
import heroBG from "../assets/images/hero-video.mp4"

export default function Hero() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        contactNumber: "",
        optionalMessage: "",
        resumeSubmission: false,
        queryType: [],
        resumeFile: null,
    });

    const handleInputChange = (e) => {
        const { name, value, type, checked, files } = e.target;
    
        setFormData((prevFormData) => {
            if (type === "checkbox") {
                return {
                    ...prevFormData,
                    [name]: type === "checkbox" ? (name === 'resumeSubmission' ? checked : [...prevFormData.queryType, value]) : prevFormData.queryType.filter(item => item !== value),
                };
            }
    
            return {
                ...prevFormData,
                [name]: type === "file" ? files[0] : value,
            };
        });
    };
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(formData);
    
        const formDataToSend = new FormData();
    
        for (const key in formData) {
            formDataToSend.append(key, key === "queryType" ? formData[key].join(", ") : formData[key]);
        }
    
        try {
            const response = await fetch('http://pillarsouthafrica.co.za/server/features/sendFormEmail.php', {
                method: 'POST',
                body: formDataToSend,
            });
    
            if (response.ok) {
                console.log('Form submitted successfully');
                // Optionally, reset the form after successful submission
                setFormData({
                    name: "",
                    email: "",
                    contactNumber: "",
                    optionalMessage: "",
                    queryType: [],
                    resumeFile: null,
                });
            } else {
                console.error('Form submission failed');
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };
    

    return (
        <div className="hero">
        <video className="background-video" autoPlay loop muted>
            <source src={heroBG} type="video/mp4" />
            Your browser does not support the video tag.
        </video>

            <div className="hero-text-wrapper">

                <div className="hero-headings-wrapper">

                    <p className="hero-subtitle hero-text">Talent Acquisition | Human Resources | Business Consultancy</p>
                    <h1 className="hero-title">Pillar South Africa,</h1>  
                    <h1 className="hero-title">your Talent Advantage</h1>   
                    
               
                </div>
                
                <div className="hero-subtext-wrapper">

                    <p className="hero-text">Pillar South Africa has been present in the staffing and business administration arenas since 2018,
                        serving small to large sized entities within the private and public sector.</p>
                    <p className="hero-text">Our pillars of service are Staffing and Labour Brokage services and; Business Administration and Consultancy.</p>
                    
                </div>

                <button className="hero-btn">TAKE THE FIRST STEP</button>
            </div>

            <form className="hero-contact-form" onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="name"
                    placeholder="Name & surname"
                    value={formData.name}
                    onChange={handleInputChange}
                />
                <input
                    type="text"
                    name="email"
                    placeholder="Email address"
                    value={formData.email}
                    onChange={handleInputChange}
                />
                <input
                    type="tel"
                    name="contactNumber"
                    placeholder="Contact number"
                    value={formData.contactNumber}
                    onChange={handleInputChange}
                />
                <input
                    type="text"
                    name="optionalMessage"
                    placeholder="Optional message"
                    value={formData.optionalMessage}
                    onChange={handleInputChange}
                />

                <p className="checkbox-title">I'm enquiring about?</p>

                <label htmlFor="resume">
                    <input
                        type="checkbox"
                        className="checkbox"
                        name="resumeSubmission"
                        id="resume"
                        checked={formData.resumeSubmission}
                        onChange={handleInputChange}
                    />
                    Resume Submissions
                </label>

                <label htmlFor="information">
                    <input
                        type="checkbox"
                        className="checkbox"
                        name="queryType"
                        id="information"
                        value="Information Desk"
                        checked={formData.queryType.includes("Information Desk")}
                        onChange={handleInputChange}
                    />
                    Information Desk
                </label>

                <label htmlFor="accounts">
                    <input
                        type="checkbox"
                        className="checkbox"
                        name="queryType"
                        id="accounts"
                        value="Accounts Department"
                        checked={formData.queryType.includes("Accounts Department")}
                        onChange={handleInputChange}
                    />
                    Accounts Department
                </label>

                <label htmlFor="directors">
                    <input
                        type="checkbox"
                        className="checkbox"
                        name="queryType"
                        id="directors"
                        value="Director's office"
                        checked={formData.queryType.includes("Director's office")}
                        onChange={handleInputChange}
                    />
                    Director's office
                </label>

                <input
                    type="file"
                    name="resumeFile"
                    id="upload-btn"
                    placeholder="but"
                    onChange={handleInputChange}
                />

                <button className="submit-btn" type="submit">
                    SUBMIT
                </button>
            </form>
        </div>
      
    )
}